export default "__VITE_ASSET__fpsqD86r__"